<template>
  <div>
    <!-- 操作 -->
    <Button type="success" style="margin: 20px 0 0;" @click="add" v-check-auth="'/user/create'">创建</Button>

    <!-- 查询条件 -->
    <Form ref="queryForm" :model="query" :label-width="60" inline>
      <FormItem label="编号">
        <Input v-model="query.id" placeholder="请输入..."></Input>
      </FormItem>
      <FormItem label="工号">
        <Input v-model="query.job_number" placeholder="请输入..."></Input>
      </FormItem>
      <FormItem label="群组">
        <group-picker v-model.number="query.group_id" ></group-picker>
      </FormItem>
      <FormItem label="是否可用">
        <Select v-model.number="query.enabled" clearable style="width:160px">
          <Option :value="1">可用</Option>
          <Option :value="0">不可用</Option>
        </Select>
      </FormItem>
      <FormItem label="关键词">
        <Input v-model="query.keyword" placeholder="请输入..."></Input>
      </FormItem>
      <FormItem label="" :label-width="0">
        <Button type="primary" icon="ios-search" @click="search">查询</Button>
        <Button type="success" style="margin-bottom: 6px; margin-left: 6px;" icon="ios-search" @click="handleExport">导出</Button>
      </FormItem>
    </Form>

    <!-- 表格&分页 -->
    <Table border :columns="columns" :data="data">
      <template slot-scope="{ row }" slot="action">
        <Button type="primary" size="small" style="margin-right: 5px" @click="update(row)" v-check-auth="'/user/update'">编辑</Button>
        <Button type="primary" size="small" style="margin-right: 5px" @click="assignment(row)" v-check-auth="'/user/update'">分配</Button>
      </template>
    </Table>
    <Page :total="totalCount" @on-change="handlePageChange" @on-page-size-change="handlePageSizeChange" size="small" show-total show-elevator show-sizer :page-size-opts="[20,50,100]" :page-size="perPage"/>

    <Modal v-model="formModal"
      :title="user.id?'编辑':'创建'">
      <Form :model="user" :label-width="100">
        <FormItem label="账号">
          <Input v-model="user.username" placeholder="请输入账号..." style="width:360px"></Input>
        </FormItem>
        <FormItem label="姓名">
          <Input v-model="user.name" placeholder="请输入姓名..." style="width:360px"></Input>
        </FormItem>
        <FormItem label="密码">
          <Input type="password" v-model="user.password"  style="width:360px"></Input>
        </FormItem>
        <FormItem label="工号">
          <Input v-model="user.job_number" placeholder="请输入工号..." style="width:360px"></Input>
        </FormItem>
        <FormItem label="邮箱">
          <Input v-model="user.email" placeholder="请输入邮箱..." style="width:360px"></Input>
        </FormItem>
        <FormItem label="通用邮箱">
          <Input v-model="user.email2" placeholder="请输入邮箱..." style="width:360px"></Input>
        </FormItem>
        <FormItem label="群组">
          <group-picker v-model="user.group_id" ></group-picker>
        </FormItem>
        <FormItem label="角色">
          <role-picker v-model="user.roles" multiple></role-picker>
        </FormItem>
        <FormItem label="工厂">
          <factory-picker v-model="user.factory_id"></factory-picker>
        </FormItem>
        <FormItem label="特殊SN作用对象">
          <Select v-model="user.affect_object_id" multiple>
            <Option :key="1" :value="1">德华安顾</Option>
            <Option :key="2" :value="2">东风汽车</Option>
            <Option :key="3" :value="3">蛮牛健康</Option>
            <Option :key="4" :value="4">江淮汽车</Option>
            <Option :key="5" :value="5">官翻品</Option>
            <Option :key="6" :value="6">内测品</Option>
            <Option :key="7" :value="7">瑕疵品</Option>
          </Select>
        </FormItem>
        <FormItem label="是否可用">
          <RadioGroup v-model="user.enabled">
            <Radio :label="1"><span>是</span></Radio>
            <Radio :label="0"><span>否</span></Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="过期时间" style="width: 225px;">
          <Date-picker type="datetime" format="yyyy-MM-dd" v-model="user.expire_at" @on-change="user.expire_at = $event"></Date-picker>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button v-if="user.id" type="primary" size="large"  @click="handleModify">确定</Button>
        <Button v-else type="primary" size="large"  @click="handleAdd">确定</Button>
        <Button size="large" @click="formModal=false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { User } from '@/services/resources'

import GroupPicker from '@/components/GroupPicker'
import RolePicker from '@/components/RolePicker'
import FactoryPicker from '@/components/FactoryPicker'

export default {
  name: 'userPage',
  components: {
    GroupPicker,
    RolePicker,
    FactoryPicker
  },
  data () {
    return {
      columns: [
        {
          title: '编号',
          width: 60,
          key: 'id'
        },
        {
          title: '账号',
          key: 'username'
        },
        {
          title: '姓名',
          key: 'name',
          width: 80,
          align: 'center'
        },
        {
          title: 'Email',
          key: 'email'
        },
        {
          title: '通用邮箱',
          key: 'email2'
        },
        {
          title: '工号',
          width: 60,
          align: 'center',
          key: 'job_number'
        },
        {
          title: '群组',
          key: 'group_name'
        },
        {
          title: '角色',
          render: (h, params) => {
            return params.row.roles.map((item) => {
              return <div>{item}</div>
            })
          }
        },
        {
          title: '工厂',
          key: 'factory_name'
        },
        {
          title: '特殊SN作用对象',
          key: 'affect_object_name'
        },
        {
          title: '是否可用',
          key: 'enabled',
          width: 80,
          align: 'center',
          render: (h, params) => {
            return (
              <div>{ params.row.enabled ? '可用' : '不可用' }</div>
            )
          }
        },
        {
          title: '创建时间',
          key: 'created_at'
        },
        {
          title: '过期时间',
          key: 'expire_at'
        },
        {
          title: '最后访问',
          key: 'last_visit'
        },
        {
          title: '操作',
          width: 180,
          slot: 'action',
          align: 'center'
        }
      ],
      // 表格数据
      data: [],
      totalCount: null,
      perPage: 20,
      page: 1,

      formModal: false,
      query: {},
      user: {}
    }
  },
  computed: {
  },
  created () {
    this.loadData()
  },
  methods: {
    async loadData () {
      let params = Object.assign({}, { 'per-page': this.perPage, 'page': this.page }, this.query)
      let resp = await User.query(params)
      this.data = resp.data
      this.totalCount = parseInt(resp.headers['x-pagination-total-count'])
    },
    handleModify () {
      User.update(this.user).then(resp => {
        this.$Message.success('更新成功')
        this.formModal = false
        this.loadData()
      })
    },
    handleAdd () {
      User.create(this.user).then(resp => {
        this.$Message.success('添加成功')
        this.formModal = false
        this.loadData()
      })
    },
    handlePageChange (page) {
      this.page = page
      this.loadData()
    },
    handlePageSizeChange (perPage) {
      this.perPage = perPage
      this.loadData()
    },
    update (row) {
      this.formModal = true
      this.user = row
    },
    add () {
      this.formModal = true
      this.user = {}
    },
    search () {
      this.loadData()
    },
    assignment (row) {
      this.$router.push({
        name: 'assignmentPage',
        params: {
          id: row.id
        }
      })
    },
    handleExport () {
      User.exportData({ 'UserSearch': { ...this.query } }).then(({ data }) => {
        this.$Message.success('导出请求已提交，请前往 工具->导出文件 下载')
      })
    }
  }
}
</script>

<style lang="scss">

</style>
